import { cn } from '@/lib/utils';

export function SvgConnector({ className, animated = false }: { className?: string; animated?: boolean }) {
  return (
    <div className={cn('flex justify-center', className)}>
      <svg width="2" height="24" className="overflow-visible">
        <line x1="1" y1="0" x2="1" y2="24" stroke={animated ? '#60a5fa' : 'rgb(var(--color-border))'} strokeWidth="2"
          strokeDasharray={animated ? '4 2' : undefined} className={animated ? 'animate-pulse' : undefined} />
      </svg>
    </div>
  );
}
